/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Form_OptimalInputs */

const en_coach_form_optimal = /** @type {(inputs: Coach_Form_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Productive Overload. Keep pushing.`)
};

const de_coach_form_optimal = /** @type {(inputs: Coach_Form_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produktive Belastung. Weiter so!`)
};

/**
* | output |
* | --- |
* | "Productive Overload. Keep pushing." |
*
* @param {Coach_Form_OptimalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_form_optimal = /** @type {((inputs?: Coach_Form_OptimalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Form_OptimalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_form_optimal(inputs)
	return de_coach_form_optimal(inputs)
});